export function createBreakpoints(breakpoints) {
    const values = Object.assign({ sm: 576, md: 768, lg: 992, xl: 1200 }, breakpoints);
    function getMinBreakpoint(key) {
        return typeof key === "number" ? key : values[key];
    }
    function getMaxBreakpoint(key) {
        return getMinBreakpoint(key) - 0.02;
    }
    function up(key) {
        return `@media (min-width: ${getMinBreakpoint(key)}px)`;
    }
    function down(key) {
        const max = getMaxBreakpoint(key);
        return `@media (max-width: ${max}px)`;
    }
    function between(lower, upper) {
        const min = getMinBreakpoint(lower);
        const max = getMaxBreakpoint(upper);
        return `@media (min-width: ${min}px) and (max-width: ${max}px)`;
    }
    function getWidth(key) {
        return typeof key === "string" ? values[key] : key;
    }
    return {
        breakpoints: {
            values,
            between,
            down,
            getWidth,
            up,
        },
    };
}
export default createBreakpoints;
//# sourceMappingURL=create-breakpoints.js.map